import { useStaticQuery, graphql } from 'gatsby'

export const useEventSlug = title => {
  const { allEvent } = useStaticQuery(eventQuery)
  const item = allEvent.nodes.filter(item => item.title === title)
  return item.length > 0 ? item[0].slug : ''
}

const eventQuery = graphql`
  query allEventQuery {
    allEvent {
      nodes {
        slug
        title
      }
    }
  }
`
